import styled from 'styled-components';

interface IAppContainer {
  children: React.ReactNode;
}

export const AppContainer = styled.div<IAppContainer>`
  text-align: center;
`;
